<template>
  <div class="page-content">
    <div class="payment">
      <div class="card">
        <CustomIcon :name="content.image" />
        <h3>{{ content.title }}</h3>
        <p>{{ descriptionMessage }}</p>
        <CustomButton variation="primary" :onClick="action"
          >Continue</CustomButton
        >
      </div>
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomButton from "@/components/CustomButton.vue";
import { MODULES } from "@/config";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      descriptionMessage: this.content.description,
    };
  },
  props: {
    content: {
      title: String,
      description: String,
      image: String,
    },
    action: {
      type: Function,
      default() {
        return null;
      },
    },
  },
  components: { CustomIcon, CustomButton },
  computed: {
    ...mapGetters(MODULES.PAYMENT, {
      orderSummary: "getOrderSummary",
    }),
  },
  mounted() {
    if (!this.orderSummary.delivery_method) {
      this.descriptionMessage =
        "Your order is complete. We will send you an email with your order details.";
    }
  },
};
</script>
